<template>
    <header class="header">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="header__content">
                        <router-link to="/" class="header__logo">
                            <img src="../../assets/img/trend_logo.png" alt="Trend Logo" class="trend-logo">
                        </router-link>

                        <!-- <nav> -->
                        <ul class="header__nav">
                            <li v-for="(item, index) in navigationItems" :key="index" class="header__nav-item">
                                <router-link :to="item.path" class="header__nav-link" :class="{ 'header__nav-link--active': $route.path === item.path }">{{ item.label }}</router-link>
                            </li>
                        </ul>
                        <!-- </nav> -->

                        <div class="header__auth">
                            <img src="../../assets/img/mtn-logo.svg" alt="MTN Logo" class="mtn-logo">
                            <!-- Search Component -->
                            <form @submit.prevent="handleSearch" class="header__search">
                                <input v-model="searchQuery" class="header__search-input" type="text" placeholder="بحث">
                                <button class="header__search-button" type="submit">
                                    <i class="ti ti-search"></i>
                                </button>
                                <button class="header__search-close" type="button" @click="toggleSearch">
                                    <i class="ti ti-x"></i>
                                </button>
                            </form>

                            <button class="header__search-btn" type="button" @click="toggleSearch">
                                <i class="ti ti-search"></i>
                            </button>

                            <!-- User Profile Dropdown -->
                            <div class="header__profile">
                                <a class="header__sign-in header__sign-in--user" href="#"
                                    @click.prevent="toggleUserMenu">
                                    <i class="ti ti-user"></i>
                                    <span>الحساب</span>
                                </a>

                                <!-- <template v-if="!isLoggedIn"> -->
                                <ul v-if="!isLoggedIn"
                                    class="dropdown-menu dropdown-menu-end header__dropdown-menu header__dropdown-menu--user"
                                    :class="{ 'show': isUserMenuOpen }">
                                    <li v-for="(item, index) in userMenuItems" :key="index">
                                        <template v-if="item.external">
                                            <a :href="item.path" target="_blank" rel="noopener">
                                                <i :class="item.icon"></i>{{ item.label }}
                                            </a>
                                        </template>
                                        <template v-else>
                                            <router-link :to="item.path">
                                                <i :class="item.icon"></i>{{ item.label }}
                                            </router-link>
                                        </template>
                                    </li>
                                </ul>
                                <ul v-else
                                    class="dropdown-menu dropdown-menu-end header__dropdown-menu header__dropdown-menu--user"
                                    :class="{ 'show': isUserMenuOpen }">
                                    <li>
                                        <router-link to="/unsubscribe">
                                            <i class="ti ti-logout"></i> إلغاء الاشتراك
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <button class="header__btn" type="button" @click="toggleMobileMenu"
                            :class="{ 'active': isMobileMenuOpen }">
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick, computed } from 'vue';
import { useRouter } from 'vue-router';
import { HTTPMTN } from '@/Api/http-mtn';

// State
const isSearchVisible = ref(false);
const searchQuery = ref('');
const isUserMenuOpen = ref(false);
const isMobileMenuOpen = ref(false);
const isLoggedIn = ref(false);
const router = useRouter();

// Navigation items
const navigationItems = computed(() => {
    const items = [
        { path: '/', label: 'الصفحة الرئيسية' },
        { path: '/facebook', label: 'فيسبوك' },
        { path: '/x', label: 'أكس' }
    ];
    if (isLoggedIn.value) {
        items.push({ path: '/contacts', label: 'اتصل بنا' });
    }
    return items;
});

// User menu items
const userMenuItems = [
    { path: '/signin', label: 'تسجيل الدخول', icon: 'ti ti-ghost' },
    { path: 'http://digitalcg.net/655/G0wo', label: 'أشتراك', icon: 'ti ti-stereo-glasses', external: true },
    // { path: '/profile', label: 'حسابي', icon: 'ti ti-ghost' }
];

// Methods
const toggleSearch = () => {
    isSearchVisible.value = !isSearchVisible.value;
    if (isSearchVisible.value) {
        nextTick(() => {
            document.querySelector('.header__search-input')?.focus();
        });
    }
};

const handleSearch = () => {
    if (searchQuery.value.trim()) {
        router.push({
            path: '/search',
            query: { q: searchQuery.value.trim() }
        });
        searchQuery.value = '';
        isSearchVisible.value = false;
    }
};

const toggleUserMenu = () => {
    isUserMenuOpen.value = !isUserMenuOpen.value;
};

const toggleMobileMenu = () => {
    isMobileMenuOpen.value = !isMobileMenuOpen.value;
    document.body.classList.toggle('menu-open');
};

// Utility to get cookie value
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}

onMounted(() => {
    // Load external script if needed
    const loadMainScript = async () => {
        try {
            await loadScript('/assets/js/main.js');
        } catch (error) {
            console.error('Failed to load main.js:', error);
        }
    };

    loadMainScript();

    // Set isLoggedIn based on cookies only
    const msisdn = getCookie('msisdn');
    const status = getCookie('status');
    const remaining_minutes = getCookie('remaining_minutes');
    isLoggedIn.value = !!(msisdn && status);

    // Optionally, you can still check/refresh cookies with API, but do not use API response for unsub button visibility
    if (msisdn && status) {
        HTTPMTN.get(`MTNCheckLogin.php?msisdn=${msisdn}`)
            .then(response => {
                const data = response.data;
                const minutes = parseInt(data.remaining_minutes, 10);
                if (data.status == 1 && data.message == 'active') {
                    if (minutes > 0) {
                        // Update cookies with latest info and correct max-age
                        const maxAge = minutes * 60;
                        document.cookie = `msisdn=${data.msisdn}; path=/; max-age=${maxAge}`;
                        document.cookie = `status=${data.status}; path=/; max-age=${maxAge}`;
                        document.cookie = `remaining_minutes=${data.remaining_minutes}; path=/; max-age=${maxAge}`;
                    } else {
                        // remaining_minutes = 0: subscribed but not renewed yet
                        // Store in cookie for 1 day so user can unsubscribe if needed
                        const oneDayInSeconds = 86400;
                        document.cookie = `msisdn=${data.msisdn}; path=/; max-age=${oneDayInSeconds}`;
                        document.cookie = `status=${data.status}; path=/; max-age=${oneDayInSeconds}`;
                        document.cookie = `remaining_minutes=0; path=/; max-age=${oneDayInSeconds}`;
                    }
                    isLoggedIn.value = true;
                } else {
                    document.cookie = 'msisdn=; Max-Age=0; path=/;';
                    document.cookie = 'status=; Max-Age=0; path=/;';
                    document.cookie = 'remaining_minutes=; Max-Age=0; path=/;';
                    isLoggedIn.value = false;
                }
            })
            .catch(err => {
                console.error('Failed to check subscription status:', err);
            });
    }

    // Close menus on outside click
    const handleClickOutside = (event) => {
        if (isUserMenuOpen.value && !event.target.closest('.header__profile')) {
            isUserMenuOpen.value = false;
        }
    };

    document.addEventListener('click', handleClickOutside);

    // Cleanup
    onUnmounted(() => {
        document.removeEventListener('click', handleClickOutside);
        document.body.classList.remove('menu-open');
    });
});

// Utility function to load external scripts
const loadScript = (src) => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
    });
};

const handleUnsubscribe = () => {
    router.push('/unsubscribe');
};
</script>

<style scoped>
.header__btn.active span:nth-child(1) {
    transform: rotate(45deg) translate(4px, 4px);
}

.header__btn.active span:nth-child(2) {
    opacity: 0;
}

.header__btn.active span:nth-child(3) {
    transform: rotate(-45deg) translate(4px, -4px);
}

.menu-open {
    overflow: hidden;
}

.trend-logo {
    height: 40px;
    width: auto;
    object-fit: contain;
}

.mtn-logo {
    height: 30px;
    width: auto;
    object-fit: contain;
    margin-right: auto;
    margin-left: 10px;
    flex-shrink: 0;
}

/* Tablet */
@media (max-width: 991px) {
    .trend-logo {
        height: 35px;
    }
    .mtn-logo {
        height: 26px;
        margin-left: 8px;
    }
}

/* Mobile */
@media (max-width: 575px) {
    .trend-logo {
        height: 28px;
    }
    .mtn-logo {
        height: 22px;
        margin-left: 5px;
        margin-right: 5px;
        order: 2;
    }
    .header__search-btn {
        order: 1;
    }
    .header__search {
        order: 3;
    }
    .header__profile {
        order: 4;
    }
}
</style>